































import Vue, { PropOptions } from 'vue';
import { CourseraAccessType, CourseraCheckHasAccessResponse } from '~/models';
import BillingService, { BillingAccount, Subscription } from '~/services/BillingService';
import CourseraService from '~/services/CourseraService';
import BillingDetailsCard from './BillingDetailsCard.vue';
import NonSubscriptionAccessCard from './NonSubscriptionAccessCard.vue';
import PaymentMethodCard from './PaymentMethodCard.vue';
import PlanDetailsCard from './PlanDetailsCard.vue';

export default Vue.extend({
    name: 'CourseraBillingPlan',
    components: {
        BillingDetailsCard,
        PlanDetailsCard,
        PaymentMethodCard,
        NonSubscriptionAccessCard,
    },
    props: {
        billingAccount: {
            type: Object,
            required: true,
        } as PropOptions<BillingAccount>,
    },
    data() {
        return {
            loading: true,
            subscriptions: [] as Subscription[],
            courseraAccess: null as CourseraCheckHasAccessResponse | null,
        };
    },
    computed: {
        subscription(): Subscription | undefined {
            return this.subscriptions[0];
        },
        accessType(): CourseraAccessType | null {
            return !this.courseraAccess ? null : this.courseraAccess.type;
        },
        accessExpiry(): Date | null {
            return !this.courseraAccess ? null : this.courseraAccess.expiresAt;
        },
    },
    methods: {
        getSubscriptions() {
            this.loading = true;
            Promise.all([
                BillingService.getSubscriptions().then(subs => {
                    this.subscriptions = subs.filter(
                        sub =>
                            sub.status !== 'canceled' &&
                            sub.product.tags.some(
                                tag => tag.key === 'category' && tag.value === 'coursera'
                            )
                    );
                }),
                CourseraService.checkHasAccess().then(res => (this.courseraAccess = res)),
            ]).finally(() => (this.loading = false));
        },
    },
    mounted() {
        this.getSubscriptions();
    },
});
